import { createUseStyles } from 'react-jss';
import { base, Color, colors } from '../../styles';

interface Props {
  backgroundColor: Color;
}

export const pairStatCardStyles = createUseStyles({
  container: ({ backgroundColor }: Props) => ({
    width: '100%',
    border: `1px solid ${['red', 'primary'].includes(backgroundColor) ? 'transparent' : colors.border}`,
    padding: `0 ${base()}`,
    height: base(7),

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    backgroundColor: colors[backgroundColor],
    '& *': {
      color: ['red', 'primary'].includes(backgroundColor) ? colors.white : colors.black,
    },
  }),
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: base(0.2),
  },
  subValuesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& *': {
      fontSize: base(0.8),
    },
  },
  secondColContainer: {
    display: 'block',
    borderLeft: `1px solid ${colors.border}`,
    paddingLeft: base(),
  },
  innerTitleContainer: {
    fontWeight: 700,
  },
});
